import * as xss from 'xss';

/**
 * @note
 * To avoid passing options each time the function is called, this can be done faster by creating
 * the `FilterXSS` instance:
 */
const htmlSanitizerInstance = new xss.FilterXSS({
  whiteList: {
    ...xss.getDefaultWhiteList(),
    a: ['href', 'name', 'target', 'rel', 'class'],
    img: ['src', 'alt', 'title', 'width', 'height', 'class'],
    div: ['class'],
    span: ['class'],
  },
  stripIgnoreTag: true,
  /**
   * @note
   * the script tag is a special case, we need to filter out its content
   */
  stripIgnoreTagBody: ['script'],
  css: true,
});

export const getSanitizedHTML = (dirtyHTML: string, sanitizerInstance: xss.FilterXSS = htmlSanitizerInstance) => {
  return sanitizerInstance.process(dirtyHTML);
};
